import { useMemo } from "react";
import { Button, Size as ButtonSize } from "@leafygreen-ui/button";
import TaskStatusBadge from "@evg-ui/lib/components/Badge/TaskStatusBadge";
import { StyledRouterLink, WordBreak } from "@evg-ui/lib/components/styles";
import {
  BaseTable,
  LGColumnDef,
  useLeafyGreenTable,
} from "@evg-ui/lib/components/Table";
import { TaskStatus } from "@evg-ui/lib/types/task";
import { isValidHttpUrl } from "@evg-ui/lib/utils/url";
import { getTaskRoute } from "constants/routes";
import { TaskBuildVariantField } from "pages/version/Tabs/TestAnalysis/types";
import { TaskTab } from "types/task";

interface FailedTestGroupTableProps {
  tasks: TaskBuildVariantField[];
}
const FailedTestGroupTable: React.FC<FailedTestGroupTableProps> = ({
  tasks,
}) => {
  const memoizedColumns = useMemo(() => getColumns(), []);

  const table = useLeafyGreenTable<TaskBuildVariantField>({
    columns: memoizedColumns,
    data: tasks,
    defaultColumn: {
      enableColumnFilter: false,
    },
  });
  return (
    <BaseTable
      data-testid="failed-test-grouped-table"
      shouldAlternateRowColor
      table={table}
    />
  );
};

const getColumns = (): LGColumnDef<TaskBuildVariantField>[] => [
  {
    header: "Task Name",
    accessorKey: "taskName",
    cell: ({ getValue, row }) => (
      <StyledRouterLink
        to={getTaskRoute(row.original.id, { tab: TaskTab.Tests })}
      >
        <WordBreak>{getValue() as string}</WordBreak>
      </StyledRouterLink>
    ),
    enableSorting: true,
  },
  {
    header: "Build Variant",
    accessorKey: "buildVariant",
    enableSorting: true,
  },
  {
    header: "Failure Type",
    accessorKey: "displayStatus",
    meta: { width: "15%" },
    cell: ({ getValue }) => (
      <TaskStatusBadge status={getValue() as TaskStatus} />
    ),
  },
  {
    header: "Logs",
    meta: { width: "10%" },
    cell: ({ row }) => {
      const { urlParsley } = row.original.logs;
      return isValidHttpUrl(urlParsley) ? (
        <Button href={urlParsley} size={ButtonSize.XSmall}>
          Parsley
        </Button>
      ) : null;
    },
  },
];

export default FailedTestGroupTable;
